export default {"src":"/_next/static/media/wallet-white.e384ba93.svg","height":18,"width":23};